import { Injectable } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';
import Icons from '../enums/icons.enum';
import { faChevronDown, faRightToBracket as fasRightToBracket, faCircleUser as fasCircleUser, faBell as fasBell, faGrid, faListCheck } from '@fortawesome/pro-solid-svg-icons';
import { faBell, faCircleUser } from '@fortawesome/pro-light-svg-icons';
import { faArrowsRotate, faGrid2, faSchoolCircleCheck, faArrowLeft, faEnvelope, faMagnifyingGlass, faCircleX, faRightToBracket, faMagnifyingGlassMinus, faBellSlash, faArrowUpRightFromSquare, faBarcodeRead, faChevronRight, faMessage, faSearchPlus, faBookOpenCover, faClock, faBriefcase, faNewspaper, faList, faGridHorizontal, faQuestionCircle, faChartMixed, faExchange, faCirclePlus, faMedal, faBooks, faArrowRightArrowLeft, faCircleQuestion, faGear, faHouse, faUsers, faChevronsLeft, faChevronsRight, faSitemap, faLaptopMobile, faComet } from '@fortawesome/pro-regular-svg-icons';
import { FaIconLibrary, IconDefinition } from '@fortawesome/angular-fontawesome';
import { faSchool } from '@fortawesome/pro-regular-svg-icons';

@Injectable({ providedIn: 'root' })
export class IconsService {
  private readonly FA_ICONS = [ faArrowsRotate, faGrid2, faSchoolCircleCheck, faArrowLeft, faEnvelope, faMagnifyingGlass, faCircleX, fasRightToBracket, fasCircleUser, fasBell, faMagnifyingGlassMinus, faBellSlash, faArrowUpRightFromSquare, faMessage, faBarcodeRead, faChevronRight, 
                                faSearchPlus, faBookOpenCover, faClock, faNewspaper, faBriefcase, faList, faQuestionCircle, faGridHorizontal, 
                                faExchange, faCirclePlus, faMedal, faQuestionCircle, faSchool, faChartMixed, faChevronsLeft, faLaptopMobile,
                                faChevronsRight, faChevronDown, faGrid, faBell, faBooks, faCircleUser, faGridHorizontal, faCircleQuestion, 
                                faGear, faUsers, faHouse, faArrowRightArrowLeft, faListCheck, faSitemap, faRightToBracket, faComet];          
    
  constructor(private matIconRegistry: MatIconRegistry, private domSanitizer: DomSanitizer, private faLibrary: FaIconLibrary) {
    this.faLibrary.addIcons(...this.FA_ICONS);
  }

  public registerIcons() {
    for (const icon of Object.values(Icons)) {
      if (!environment.production && this.isDevOnlyIcon(icon)) {
        this.matIconRegistry.addSvgIcon( icon, this.domSanitizer.bypassSecurityTrustResourceUrl(`assets/icons/dev-only/${icon}.svg`) );
      } else {
        this.matIconRegistry.addSvgIcon( icon, this.domSanitizer.bypassSecurityTrustResourceUrl(`assets/icons/${icon}.svg`) );
      }
    };
  }

  private isDevOnlyIcon(icon: Icons) {
    return Icons.SECRET === icon || Icons.PALETTE === icon || Icons.SEND === icon;
  }

  public getFaIcon(iconName: string): IconDefinition {
    return this.FA_ICONS.find(icon => icon.iconName === iconName) || faQuestionCircle;
  }
}
